import { ICommercialBreadcrumbs } from 'shared/types/commercialBreadcrumbs';
import { IOffersData } from 'shared/types/offersData';

import {
  IPageChangeStartedAction,
  FILTERS_PAGINATION_PAGE_CHANGE_STARTED,
  IPageChangeFinishedAction,
  FILTERS_PAGINATION_PAGE_CHANGE_FINISHED,
} from './types';

export const pageChangeStarted = (): IPageChangeStartedAction => ({
  type: FILTERS_PAGINATION_PAGE_CHANGE_STARTED,
});

export const pageChangeFinished = (
  data: IOffersData,
  paginationUrls: string[],
  commercialBreadcrumbs: ICommercialBreadcrumbs | null = null,
): IPageChangeFinishedAction => ({
  type: FILTERS_PAGINATION_PAGE_CHANGE_FINISHED,
  data,
  paginationUrls,
  commercialBreadcrumbs,
});
